// extracted by mini-css-extract-plugin
module.exports = {"root":"WishlistCard_root__I4EMF","productBg":"WishlistCard_productBg__4Lrqi"};